import {
  Navbar,
  Nav,
  ButtonGroup,
  Button,
  DropdownButton,
  Dropdown,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  ArrowLeftCircle,
  Bezier2,
  BoundingBoxCircles,
  ArrowRightCircle,
  Calendar3,
  ArrowsAngleExpand,
  Badge3d,
  XCircle,
  HandIndex,
} from "react-bootstrap-icons";
import { BottomToolbarProps } from "../interfaces/Toolbar";
import AnimateChoreoButton from "./AnimateChoreoButton";
import { useEffect, useState } from "react";
import { loadFootCode } from "../services/Foot";

function BottomNavbar(props: BottomToolbarProps) {
  const [activeDropdownItem, setActiveDropdownItem] = useState(0);

  /**
   * Sets the currently active dropdown item and activates the selected mode.
   * In case of the default mode, all other modes will be deactivated instead.
   *
   * @param e Event key of the selected dropdown item (is a string in this case)
   */
  const handleModeSelect = (e: any) => {
    setActiveDropdownItem(Number(e));
    switch (Number(e)) {
      case 0:
        props.deactivate3DView();
        props.deactivateHeatmap();
        props.deactivateOrientations();
        props.deactivateShapes();
        props.deactiveTransitions();
        props.deactivateTangentBodyParts();
        break;
      case 1:
        props.activate3DView();
        break;
      case 2:
        props.activateOrientations();
        break;
      case 3:
        props.activateTransitions();
        break;
      case 4:
        props.activateShapes();
        break;
      case 5:
        props.activateTangentBodyParts();
        break;
      case 6:
        props.activateHeatmap();
        break;
      default:
    }
  };

  const handlePatternSelect = (e: any) => {
    props.setSelectedPattern(Number(e));
  };

  return (
    <Navbar fixed="bottom" bg="dark" variant="dark" className="only-for-mobile">
      <DropdownButton
        as={ButtonGroup}
        key={"Secondary"}
        id={`mode-dropdown`}
        variant={"light"}
        title={"Mode"}
        drop={"up"}
        className="ms-1"
        onSelect={handleModeSelect}
      >
        <Dropdown.Item eventKey="6" active={6 == activeDropdownItem}>
          <Calendar3 /> Analysis
        </Dropdown.Item>
        <Dropdown.Item eventKey="5" active={5 == activeDropdownItem}>
          <svg width={20} height={20}>
            {loadFootCode(
              "translate(3,20)",
              0.0015,
              !props.showTangentBodyParts ? "black" : "white",
              true,
              true
            )}
          </svg>{" "}
          Point
        </Dropdown.Item>
        <Dropdown.Item eventKey="4" active={4 == activeDropdownItem}>
          <BoundingBoxCircles /> Shapes
        </Dropdown.Item>
        <Dropdown.Item eventKey="3" active={3 == activeDropdownItem}>
          <Bezier2 /> Transitions
        </Dropdown.Item>
        <Dropdown.Item eventKey="2" active={2 == activeDropdownItem}>
          <ArrowsAngleExpand /> Orientations
        </Dropdown.Item>
        <Dropdown.Item eventKey="1" active={1 == activeDropdownItem}>
          <Badge3d /> 3D
        </Dropdown.Item>
        <Dropdown.Item eventKey="0" active={0 == activeDropdownItem}>
          <XCircle /> Default
        </Dropdown.Item>
      </DropdownButton>

      <AnimateChoreoButton
        nextClick={props.nextClick}
        setSelectedPattern={props.setSelectedPattern}
        selectedPattern={props.selectedPattern}
        choreoLength={props.choreo.patterns.length}
        setShowSliderForAnimatedChoreo={props.setShowSliderForAnimatedChoreo}
        speedForAnimatedChoreo={props.speedForAnimatedChoreo}
        setSpeedForAnimatedChoreo={props.setSpeedForAnimatedChoreo}
        forBottomToolbar={true}
        setCurrentlyInAnimation={props.setCurrentlyInAnimation}
        choreo={props.choreo}
        animationSpeed={props.animationSpeed}
      />

      <Nav className="justify-content-end" style={{ width: "100%" }}>
        <DropdownButton
          title={props.choreo.patterns[props.selectedPattern].name.slice(0, 8)}
          as={ButtonGroup}
          onSelect={handlePatternSelect}
          variant={"light"}
          drop="up"
          className="me-1"
          align="end"
        >
          <div className={"scrollable"}>
            {props.selectOptions.map(({ value, label, key }) => (
              <div key={key}>
                <Dropdown.Item
                  event={value}
                  eventKey={key}
                  active={value == props.selectedPattern}
                >
                  {label}
                </Dropdown.Item>
              </div>
            ))}
          </div>
        </DropdownButton>

        <ButtonGroup className=" me-1">
          <Button
            variant="light"
            onClick={props.prevClick}
            disabled={props.prevDisabled}
            title="Previous pattern"
          >
            <ArrowLeftCircle fontSize={14} />
          </Button>
          <Button
            variant="light"
            onClick={props.nextClick}
            disabled={props.nextDisabled}
            title="Next pattern"
          >
            <ArrowRightCircle fontSize={14} />
          </Button>
        </ButtonGroup>
      </Nav>
    </Navbar>
  );
}

export default BottomNavbar;
